import {GetterTree} from 'vuex';
import {CalendarState} from '@/modules/calendar/store/index';
import {RootState} from '@/store/types';
import moment from 'moment'
import CalendarEventType from '@/modules/calendar/model/CalendarEventType';

const getters: GetterTree<CalendarState, RootState> = {
    /**
     * Retorna la lista de eventos de mes que coincidan con la fecha introducida
     *
     * @param state
     */
    matchedEvents: (state) => (date: Date | string) => {
        if (typeof date === 'string') {
            date = moment(date, 'YYYY-MM-DD').toDate()
        }

        return state.calendarEvents.filter((e => e.match(date as Date)))
    },

    /**
     * Retorna los evento asociados al tipo de evento argumentado
     *
     * @param state
     */
    eventsOfType: state => (type: CalendarEventType) => {
        return state.calendarEvents.filter(e => e.type.id === type.id)
    },

    /**
     * Indica si el tipo de evento argumentado tiene eventos asociados
     *
     * @param state
     * @param getters
     */
    eventTypeHasEvents: (state, getters) => (type: CalendarEventType) => getters.eventsOfType(type).length > 0,
}

export default getters

